module.exports = __webpack_public_path__ + "static/media/tea1.419a7d62.png";